<template>
 <div class="container pr-4 pl-4 pt-5 pb-2">
        <div class="text-center pt-2 pb-4">
            <h3 class="font-weight-normal">ขอรายการสเตทเม้นต์ย้อนหลัง</h3>
            <p class="font-weight-lighter">รับรายการย้อนหลังในรูปแบบเอกสาร PDF มีค่าธรรมเนียมในการออกเอกสาร</p>
            <p class="font-weight-lighter">ขณะนี้ท่านมีเงินอยู่ {{ current_money }} บาท</p>
        </div>
        <div class="text-center pb-2 pt-4">
            <form>
                <div class="form-group pb-2">
                    <select id="default-select-statement-page" v-model="period" class="form-control">
                        <option value="3">ย้อนหลัง 3 เดือน (เสียค่าธรรมเนียม 30 บาท)</option>
                        <option value="6">ย้อนหลัง 6 เดือน (เสียค่าธรรมเนียม 60 บาท)</option>
                        <option value="12">ย้อนหลัง 1 ปี (เสียค่าธรรมเนียม 100 บาท)</option>
                    </select>
                </div>
                <button class="btn btn-primary btn-block btn-lg mt-4" type="button" @click="viewStatement()">ขอสเตทเม้นท์</button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            period: 3,
            current_money: 0
        };
    },
    created: function() {
        axios.post(`/member/load-current-money`).then(({ data }) => {
            if (data != null) {
                this.current_money = data.current_money;
            }
        });
    },
    methods: {
        viewStatement() {
            if((this.period == 3 && this.current_money >= 30) || (this.period == 6 && this.current_money >= 60) || (this.period == 12 && this.current_money >= 100)) {
                window.open('view-statement?period=' + this.period);
            } else {
                alert("คุณมีเงินไม่พอสำหรับจ่ายค่าธรรมเนียม");
            }
        }
    }
}
</script>

<style lang="scss">
</style>
